import { render, staticRenderFns } from "./firebaseDetailsModal.vue?vue&type=template&id=ffa9ed0c&"
import script from "./firebaseDetailsModal.vue?vue&type=script&lang=js&"
export * from "./firebaseDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./firebaseDetailsModal.vue?vue&type=style&index=0&id=ffa9ed0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports